// src/components/GlobalAlert.js
import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import useStore from '../config/store';

const GlobalAlert = () => {
  const { alertOpen, alertMessage, alertSeverity, closeAlert } = useStore();

  return (
    <Snackbar
      open={alertOpen}
      autoHideDuration={4000}
      onClose={closeAlert}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert onClose={closeAlert} severity={alertSeverity} variant="filled" sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};

export default GlobalAlert;
